var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-article--rich"},_vm._l((_vm.slices),function(slice,index){return _c(_vm.getSliceComponent(slice),{key:index,tag:"component",attrs:{"slice":slice}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }